import type { IconSvgObject } from './types';

const AirVentIcon: IconSvgObject = [
  ["path", { d: "M4 15C2.89543 15 2 14.1046 2 13V6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V13C22 14.1046 21.1046 15 20 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 10H18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16 15V16C16 18.2091 17.7909 20 20 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M8 15V16C8 18.2091 6.20914 20 4 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M12 20V15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default AirVentIcon;
